module.exports = __webpack_public_path__ + "img/home-fences.1f60248c.svg";